import { authService } from '@/services/auth.js';

class HatAppLanding extends HTMLElement {
  private _unsubscribe: (() => void) | null = null;

  constructor() {
    super();
  }

  async connectedCallback() {
    await this.render();

    this._unsubscribe = authService.subscribe((event) => {
        if (event.status === 'tokenRefreshed') {
            // console.log("HatLogin detected authentication, navigating to /app");
            this.render();}
    });
  }

  disconnectedCallback() {
    if (this._unsubscribe) this._unsubscribe();
  }

  async render() {
    // console.log('HatAppLanding render start');
    let isAuthenticated = authService.isAuthenticated();
    const userType = authService.getUserType();
    if (!isAuthenticated) {
      this.innerHTML = `
        <p>Please Log in to view your content</p>
        <p><hat-nav-button href="/app/login">Login</hat-nav-button></p>
      `;
      return;
    }
    console.log("userType", userType);
    if (userType === 'NONE') {
      this.innerHTML = `
        <hat-private-beta></hat-private-beta>
      `;
    } else {
      this.innerHTML = `
        <hat-locations></hat-locations>
      `;
    }
  }
}

customElements.define('hat-app-landing', HatAppLanding);